import { render, staticRenderFns } from "./ChargingPointDetailLicences.vue?vue&type=template&id=0b504616"
import script from "./ChargingPointDetailLicences.vue?vue&type=script&lang=js"
export * from "./ChargingPointDetailLicences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports